import { BREAK_CARD, cardLabel } from '@planning-session/shared';
import { BreakIcon } from './Icon.js';

export interface CardFaceProps {
  readonly value: string;
  /** Icon size for the break card, matched to the surrounding type size. */
  readonly iconSize?: number;
}

/**
 * What is printed on the face of a card. Values are typography; the break card is
 * the one face that is drawn, because "Break" does not fit a 3.5rem card.
 */
export function CardFace({ value, iconSize = 24 }: CardFaceProps) {
  if (value === BREAK_CARD) return <BreakIcon size={iconSize} />;
  return <>{cardLabel(value)}</>;
}
